<template>
    <div class="content">
        <div class="top">
            <div class="content-item title">中教智融云</div>
            <ce-module class="content-item ce"></ce-module>
            <cai-module class="content-item cai"></cai-module>
            <bian-module class="content-item bian"></bian-module>
            <fa-module class="content-item fa"></fa-module>
        </div>
        <!--<main-content></main-content>-->
        <new-publish></new-publish>
    </div>
</template>

<script>
    import MainContent from '@/views/index/mainContent.vue'
    import NewPublish from '@/views/index/newPublish.vue'
    import CeModule from '@/views/index/ceModule.vue'
    import BianModule from '@/views/index/bianModule.vue'
    import CaiModule from '@/views/index/caiModule.vue'
    import FaModule from '@/views/index/faModule.vue'
    export default {
        name: "Content",
        data() {
            return{

            }
        },
        components: { MainContent, NewPublish, CeModule, BianModule, CaiModule,FaModule },
        created(){},
        mounted() {},
        computed:{},
        methods:{},
        beforeDestroy() {},
    }
</script>

<style scoped>
    .content{
        color: #fff;
        position: relative;
    }
    .content .content-item{
        position: absolute;
    }
    .content .top{
        height: 1170px;
    }
    .content .title{
        font-size: 50px;
        /*font-weight: bold;*/
        left: 632px;
        top: 460px;
        font-family: hyk1gj;
    }
    .ce{
        top: 0;
        left: -10px;
    }
    .bian{
        left: 850px;
        top: 850px;
    }
    .cai{
        top: 0;
        right: 0;
    }
    .fa{
        left: 100px;
        top: 850px;
    }
</style>
